import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    // Dans le Dashboard v3, globalData sert souvent à initialiser un cache.
    // On appelle l'endpoint de stats qui donne un bon aperçu global.
    return buildApiUrl(ADMIN_ENDPOINTS.DASHBOARD_STATS)
  },

  parse(raw = {}, payload = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch global data',
        data: null,
      }
    }

    const stats = raw.data || {}

    // Mise à jour du cache global en window pour les composants qui le lisent
    if (typeof window !== 'undefined') {
      window.__RAPIDOO_GLOBAL_DATA__ = {
        ...stats,
        lastUpdate: Date.now(),
        // On initialise des tableaux vides pour éviter les crashs JS sur des .map()
        restaurants: stats.restaurants || [],
        orders: stats.orders_list || [], // On pourrait mapper une liste courte si le backend en donnait une
        customers: [],
        riders: [],
        dishes: [],
        notifications: [],
        coupons: [],
        drinks: [],
        categories: [],
        milestones: [],
        promotions: [],
        deals: [],
        adds: [],
      }
    }

    return {
      statusCode: 200,
      message: 'Ok',
      data: stats,
    }
  },
}
